<div *ngIf="closure_html" class="mt-3 notranslate" [ngClass]="{'text-center': closure_html == 'Loading...'}">
    <div class="notranslate" [innerHtml]="closure_html | safeHtml"></div>
</div>